// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__kS_OJ","file":"styles_file__yG7GL"};